export default {
  'Resize for': 'Formaat wijzigen voor',
  'Add 10 videos at most': "Voeg hooguit 10-video's toe.",
}